import {load} from '@shopify/theme-sections';

import '../sections/tagalys-recommendations';
import '../sections/tagalys-vav';
import '../sections/tagalys-bab';

import hideMediaArrow from '../components/media-arrow';

const template = 'product';

function toggleTagalys(e) {
  const containers = document.querySelectorAll('.tagalys-toggle');
  const triggers = document.querySelectorAll('.tagalys-toggle-trigger');
  const selectedItem = e.getAttribute('data-item');

  for (let i = 0; i < containers.length; i++) {
    let element = containers[i];
    if (element.classList.contains(selectedItem)) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  }

  for (let i = 0; i < triggers.length; i++) {
    let element = triggers[i];
    if (element == e) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  }
}

export default (function () {
  if (document.body.dataset.template.includes(template) == false) return;

  // Handle product form submit -> add product to cart
  const productForm = document.querySelector('[data-product-form]');
  const formElements = productForm?.elements;

  productForm?.addEventListener('submit', (event) => {
    event.preventDefault();

    const variantID = formElements['id']?.value;
    const quantity = formElements['quantity']?.value ?? 1;

    if (!variantID) return;

    const item = {
      id: variantID,
      quantity: quantity,
    };
    window.sideCart.handleAddToCartEvent(item, true);
  });

  document.querySelector('.btn-cart.inactive')?.addEventListener('click', () => {
    const sizeSelector = document.querySelector('.select-size-message');
    sizeSelector.classList.remove('hide');

    setTimeout(() => {
      sizeSelector.classList.add('hide');
    }, 5000);
  });

  document.querySelector('.size-chart')?.addEventListener('click', () => {
    const sizeBestFitsCol = document.querySelector(
      '.product-measurements .table-area tbody tr:first-child td:nth-child(2)'
    );

    if (sizeBestFitsCol.textContent === 'Best Fits') {
      document.querySelector('.table-area').classList.add('static-col');
    }
  });

  load('*');

  hideMediaArrow();

  const triggers = document.querySelectorAll('.tagalys-toggle-trigger');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => toggleTagalys(e.target));
  });
})();
